<template>
  <v-container fluid>
  <v-form ref="form"
          v-model="valid"
          lazy-validation
          v-if="languageData.registerForm && languageData.labels"
  >
    <div class="d-flex justify-center">
      <div class="flex-column login-form-wrapper">
        <v-col>
          <p class="login-slogan display-2 text-center font-weight-medium mt-10">{{ languageData.registerForm.headFirst }}</p>
          <p class="login-slogan display-1 text-center font-weight-medium mb-1">{{ languageData.registerForm.headSecond }}</p>
        </v-col>
          <v-col>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    v-model="data.firstname"
                    :rules="this.rules.firstname"
                    :label="languageData.labels.firstname"
                    single-line
                    required></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="data.lastname"
                    :rules="this.rules.lastname"
                    :label="languageData.labels.lastname"
                    single-line
                    required></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
                v-model="data.email"
                :rules="this.rules.email"
                :label="languageData.labels.email"
                single-line
                required></v-text-field>
            <v-text-field
                light
                v-model="data.password"
                :rules="this.rules.password"
                single-line
                type="password"
                :label="languageData.labels.password"
                autocomplete="on"
                required ></v-text-field>
            <v-text-field
                light
                v-model="data.password_confirmation"
                :rules="this.rules.password_confirmation"
                single-line
                type="password"
                :label="languageData.labels.password_confirmation"
                autocomplete="on"
                required></v-text-field>
          </v-col>
          <v-col style="padding-top: 0 !important">
            <v-col cols="12" style="padding-top: 0 !important; padding-bottom: 0 !important">
              <v-checkbox
                v-model="data.agreementFirst"
                :value="true"
                :rules="[v => !!v]"
              >
                <template v-slot:label>
                  <p class="caption" style="line-height: 20px"><span>{{ languageData.registerForm.agreementFirst }}</span><a v-on:click.stop href="https://support.einklick.net/knowledgebase/allgemeine-geschaftsbedingungen">{{ languageData.registerForm.termsAndConditions }}</a><span>{{ languageData.registerForm.restOfAgreementFirst }}</span></p>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" style="margin-top: -25px; padding-top: 0 !important; padding-bottom: 0 !important">
              <v-checkbox
                v-model="data.agreementSecond"
                :value="true"
                :rules="[v => !!v]"
              >
                <template v-slot:label>
                  <p class="caption" style="line-height: 20px"><span>{{ languageData.registerForm.agreementSecond }}</span><a v-on:click.stop href="https://support.einklick.net/knowledgebase/datenschutzerklärung">{{ languageData.registerForm.dataProtection }}</a><span>{{ languageData.registerForm.restOfAgreementSecond }}</span></p>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="d-flex justify-space-between">
              <v-btn
                color="primary"
                class="button-shadow mr-4"
                :loading="regIsFetching"
                @click="register">
              {{ languageData.registerForm.btnText }}
            </v-btn>
            </v-col>  
          </v-col>
      </div>
    </div>
    </v-form>
    <ModalInfo :headModal="modalData.headInfoRegister" :typeInfo="modalData.typeInfoRegister" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isUserRegister" :text-modal="modalData.textInfoRegister"></ModalInfo>
  </v-container>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";

  export default {
    name: "RegisterForm",
    created() {
      eventBus.$on("failureRegister", (errorsData) => {
        this.rules = handleFormError(errorsData);

        this.$refs.form.validate();
      });
      eventBus.$on("resetFormValidation", this.resetForm);
    },
    data() {
      return {
          data: {},
          valid: false,
          rules: {},
      }
    },
    components: {
      ModalInfo
    },
    computed: {
      ...mapState('registerMain', {
        regIsFetching: state => state.isFetching,
        modalData: state => state.modalData,
        isUserRegister: state => state.isUserRegister
      } )
    },
    methods: {
      ...mapActions('registerMain', ['registerUser', 'updateVisibleModal']),
      register: function() {
        this.data.language = this.language;
        this.rules = [];
        this.$refs.form.resetValidation();
        if (this.$cookies.get('affiliate-partner')) {
          this.data.affiliatePartner = Number(this.$cookies.get('affiliate-partner'));
        }
        this.registerUser({ creds: this.data });
      },
      hideModal: function() {
        this.updateVisibleModal(false);
      },
      resetForm: function() {
        this.$refs.form.resetValidation();
      },
    },
  }
</script>